import type { TPricing } from "~/components/cards/Pricing.vue";

export const cloudPbxPrices: Array<TPricing & { prefix?: '9' | '8' }> = [
    {
      title: "بسته پایه",
      desc: "شروع ارتباطات کسب‌وکار",
      img: "/img/new/pricing/paye.webp",
      prefix: "8",
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '438' },
            { max: 2, price: '350' },
            { max: 3, price: '290' },
            { max: 4, price: '249' },
            { max: 9, price: '210' },
            { max: 19, price: '192' },
            { max: 29, price: '183' },
            { max: 49, price: '165' },
            { max: 99, price: '162' },
            { max: 199, price: '162' },
            { max: 299, price: '162' },
            { min: 300, price: '162' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "اپلیکیشن اختصاصی", value: true },
        { title: "پنل مدیریتی پیشرفته", value: true },
        { title: "تلفن گویا چند سطحی", value: true },
        { title: "صف تماس با استراتژی‌های مختلف", value: true },
        { title: "گزارش تماس‌ها", value: true },
        { title: "پیام‌رسانی سازمانی", value: true },
        { title: "نظرسنجی تماس و گزارش عملکرد", value: true },
        { title: "اتصال به IP-Phone", value: true },
      ]
    },
    {
      title: "بسته عملیاتی",
      desc: "مرکز تماس حرفه‌ای",
      img: "/img/new/pricing/amalyati.webp",
      prefix: "8",
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '526' },
            { max: 2, price: '420' },
            { max: 3, price: '348' },
            { max: 4, price: '294' },
            { max: 9, price: '252' },
            { max: 19, price: '235' },
            { max: 29, price: '227' },
            { max: 49, price: '220' },
            { max: 99, price: '216' },
            { max: 199, price: '216' },
            { max: 299, price: '216' },
            { min: 300, price: '216' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته پایه+", value: true, isBoldText: true },
        { title: "مانیتورینگ زنده کاربران", value: true },
        { title: "کنترل، نجوا و ورود به مکالمات", value: true },
        { title: "گزارش تماس‌های از دست رفته", value: true },
        { title: "ثبت اطلاعات و مدیریت مخاطبان", value: true },
        { title: "مدیریت نقش، سطوح و حقوق", value: true },
        { title: "تعریف دپارتمان", value: true },
        { title: "پاپ آپ تماس و کلیک تو کال", value: true },
      ]
    },
    {
      title: "بسته یکپارچه",
      desc: "همه کانال‌های ارتباطی در یک بستر",
      img: "/img/new/pricing/yekparche.webp",
      prefix: "8",
      boldCard: {
        type: 'popular',
        title: 'محبوب‌ترین',
      },
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '684' },
            { max: 2, price: '548' },
            { max: 3, price: '455' },
            { max: 4, price: '383' },
            { max: 9, price: '328' },
            { max: 19, price: '300' },
            { max: 29, price: '287' },
            { max: 49, price: '279' },
            { max: 99, price: '274' },
            { max: 199, price: '274' },
            { max: 299, price: '274' },
            { min: 300, price: '274' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته عملیاتی+", value: true, isBoldText: true },
        { title: "تاریخچه تعاملات و پروفایل ۳۶۰ درجه", value: true },
        { title: "پنل پیامکی", value: true },
        { title: "چت آنلاین سایت", value: true },
        { title: "اتصال به واتس‌اپ", value: true },
        { title: "مدیریت وظایف", value: true },
        { title: "مدیریت تیکت‌ها", value: true },
        { title: "اتوماسیون گردش کار", value: true }
      ]
    },
    {
      title: "بسته فراگیر",
      desc: "کامل‌ترین راهکار ارتباط با مشتری",
      img: "/img/new/pricing/faragir.webp",
      prefix: "8",
      boldCard: {
        type: 'suggest',
        title: "پیشنهاد نواتل",
      },
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '885' },
            { max: 2, price: '684' },
            { max: 3, price: '568' },
            { max: 4, price: '444' },
            { max: 9, price: '391' },
            { max: 19, price: '358' },
            { max: 29, price: '343' },
            { max: 49, price: '334' },
            { max: 99, price: '329' },
            { max: 199, price: '329' },
            { max: 299, price: '329' },
            { min: 300, price: '329' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته یکپارچه+", value: true, isBoldText: true },
        { title: "کلیه قابلیت‌های مرکز تماس", value: true },
        { title: "کلیه قابلیت‌های CRM", value: true },
        { title: "مدیریت سرنخ‌ها", value: true },
        { title: "مدیریت فرصت فروش", value: true },
        { title: "مدیریت محصولات", value: true },
        { title: "انبارداری", value: true },
        { title: "فاکتور و پیش فاکتور", value: true }
      ]
    },
    {
      title: "بسته پایه",
      desc: "شروع ارتباطات کسب‌وکار",
      img: "/img/new/pricing/paye.webp",
      prefix: "9",
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '360' },
            { max: 2, price: '250' },
            { max: 3, price: '174' },
            { max: 4, price: '154' },
            { max: 9, price: '126' },
            { max: 19, price: '122' },
            { max: 29, price: '120' },
            { max: 49, price: '117' },
            { max: 99, price: '115' },
            { max: 199, price: '115' },
            { max: 299, price: '115' },
            { min: 300, price: '115' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "اپلیکیشن اختصاصی", value: true },
        { title: "پنل مدیریتی پیشرفته", value: true },
        { title: "تلفن گویا چند سطحی", value: true },
        { title: "صف تماس با استراتژی‌های مختلف", value: true },
        { title: "گزارش تماس‌ها", value: true },
        { title: "پیام‌رسانی سازمانی", value: true },
        { title: "نظرسنجی تماس و گزارش عملکرد", value: true },
        { title: "اتصال به IP-Phone", value: true },
      ]
    },
    {
      title: "بسته عملیاتی",
      desc: "مرکز تماس حرفه‌ای",
      img: "/img/new/pricing/amalyati.webp",
      prefix: "9",
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '448' },
            { max: 2, price: '320' },
            { max: 3, price: '232' },
            { max: 4, price: '199' },
            { max: 9, price: '168' },
            { max: 19, price: '165' },
            { max: 29, price: '163' },
            { max: 49, price: '160' },
            { max: 99, price: '158' },
            { max: 199, price: '158' },
            { max: 299, price: '158' },
            { min: 300, price: '158' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته پایه+", value: true, isBoldText: true },
        { title: "مانیتورینگ زنده کاربران", value: true },
        { title: "کنترل، نجوا و ورود به مکالمات", value: true },
        { title: "گزارش تماس‌های از دست رفته", value: true },
        { title: "ثبت اطلاعات و مدیریت مخاطبان", value: true },
        { title: "مدیریت نقش، سطوح و حقوق", value: true },
        { title: "تعریف دپارتمان", value: true },
        { title: "پاپ آپ تماس و کلیک تو کال", value: true },
      ]
    },
    {
      title: "بسته یکپارچه",
      desc: "همه کانال‌های ارتباطی در یک بستر",
      img: "/img/new/pricing/yekparche.webp",
      prefix: "9",
      boldCard: {
        type: 'popular',
        title: "محبوب‌ترین",
      },
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '606' },
            { max: 2, price: '448' },
            { max: 3, price: '339' },
            { max: 4, price: '288' },
            { max: 9, price: '244' },
            { max: 19, price: '230' },
            { max: 29, price: '224' },
            { max: 49, price: '219' },
            { max: 99, price: '215' },
            { max: 199, price: '215' },
            { max: 299, price: '215' },
            { min: 300, price: '215' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته عملیاتی+", value: true, isBoldText: true },
        { title: "تاریخچه تعاملات و پروفایل ۳۶۰ درجه", value: true },
        { title: "پنل پیامکی", value: true },
        { title: "چت آنلاین سایت", value: true },
        { title: "اتصال به واتس‌اپ", value: true },
        { title: "مدیریت وظایف", value: true },
        { title: "مدیریت تیکت‌ها", value: true },
        { title: "اتوماسیون گردش کار", value: true }
      ]
    },
    {
      title: "بسته فراگیر",
      desc: "کامل‌ترین راهکار ارتباط با مشتری",
      img: "/img/new/pricing/faragir.webp",
      prefix: "9",
      boldCard: {
        type: 'suggest',
        title: "پیشنهاد نواتل",
      },
      amounts: [
        { 
          title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
          value: [
            { max: 1, price: '807' },
            { max: 2, price: '584' },
            { max: 3, price: '452' },
            { max: 4, price: '349' },
            { max: 9, price: '307' },
            { max: 19, price: '288' },
            { max: 29, price: '280' },
            { max: 49, price: '274' },
            { max: 99, price: '269' },
            { max: 199, price: '269' },
            { max: 299, price: '269' },
            { min: 300, price: '269' },
          ], 
          unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته یکپارچه+", value: true, isBoldText: true },
        { title: "کلیه قابلیت‌های مرکز تماس", value: true },
        { title: "کلیه قابلیت‌های CRM", value: true },
        { title: "مدیریت سرنخ‌ها", value: true },
        { title: "مدیریت فرصت فروش", value: true },
        { title: "مدیریت محصولات", value: true },
        { title: "انبارداری", value: true },
        { title: "فاکتور و پیش فاکتور", value: true }
      ]
    }
];


export const cloudPbxComparePlans = {
  header: ['', 'بسته پایه', 'بسته عملیاتی', 'بسته یکپارچه', 'بسته فراگیر'],
  data: [
    {
      title: 'ویژگی های اصلی',
      items: [
        ['فضای ابری', '0.5', '1', '2', '5'],
        ['پروفایل', '0', '20,000', '30,000', '50,000'],
        ['تعداد فرصت فروش', '0', '20,000', '30,000', '50,000'],
        ['پنل مدیریتی پیشرفته', true, true, true, true],
        ['اتصال از طریق API به امکانات مختلف پنل', true, true, true, true],
        ['تاریخچه تعاملات', false, false, true, true],
        ['نمایش پاپ آپ تماس', false, true, true, true]
      ]
    },
    {
      title: 'اپلیکیشن تخصصی',
      items: [
        ['نسخه نیتیو اندروید، ویندوز، iOS و لینوکس', true, true, true, true],
        ['دفترچه تلفن', true, true, true, true],
        ['مشاهده پروفایل مخاطب', false, true, true, true],
        ['هولد تماس', true, true, true, true],
        ['ترنسفر تماس', true, true, true, true],
        ['تماس داخلی به داخلی', true, true, true, true],
        ['پیام‌رسانی، ایجاد گروه و کانال، ارسال فایل', true, true, true, true],
        ['تماس تصویری', true, true, true, true],
        ['شارژ کیف پول', true, true, true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['ارسال پیامک تکی', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال پیامک گروهی', 'قابل خرید', 'قابل خرید', true, true],
        ['تنظیمات پیشرفته تماس', true, true, true, true],
        ['تنظیم سرشماره', true, true, true, true],
        ['رعایت الزامات رمزگذاری اطلاعات', true, true, true, true],
        ['تنطیمات میکروفون', true, true, true, true],
        ['تنظیمات زنگ تماس', true, true, true, true],
        ['برقراری تماس بدون اینترنت بین الملل', true, true, true, true],
        ['مشاهده وضعیت مرکز تماس', true, true, true, true],
        ['تنظیم Swipe Actions برای تماس، مخاطبین و پیام ها', true, true, true, true],
        ['ارسال پیام از طریق واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'تنظیمات تماس',
      items: [
        ['تعیین شروط زمانی بر اساس ماه، روز و ساعت', true, true, true, true],
        ['تعریف شماره دایورتی', true, true, true, true],
        ['پیامگیر صوتی', true, true, true, true],
        ['تنظیمات ضبط مکالمات', true, true, true, true],
        ['تعریف لیست سیاه', true, true, true, true],
        ['تعیین مقصد تماس', true, true, true, true]
      ]
    },
    {
      title: 'تنظیمات صف',
      items: [
        ['تعریف صف تماس', true, true, true, true],
        ['استراتژی‌های مختلف پاسخگویی', true, true, true, true],
        ['انتخاب آوای انتظار', true, true, true, true],
        ['تعیین زمان انتظار', true, true, true, true],
        ['تعیین عملیات پس از پایان زمان انتظار', true, true, true, true],
        ['فعالسازی ضبط مکالمه', true, true, true, true],
        ['فعالسازی نظرسنجی', true, true, true, true],
        ['فعال‌سازی تماس امن ورودی', true, true, true, true],
        ['اعلام تعداد نفرات در صف', true, true, true, true],
        ['اعلام میانگین زمان انتظار', true, true, true, true]
      ]
    },
    {
      title: 'تلفن گویا (IVR)',
      items: [
        ['تعریف منو', true, true, true, true],
        ['منوهای چند سطحی', true, true, true, true],
        ['تعریف سناریو برای هر گزینه', true, true, true, true],
        ['داخلی اختصاصی 3 و 4 رقمی', true, true, true, true],
        ['تعیین عملیات پس از اتمام IVR', true, true, true, true],
        ['اتصال به آخرین اپراتور', true, true, true, true]
      ]
    },
    {
      title: 'مانیتورینگ مرکز تلفن',
      items: [
        ['پیشخوان', true, true, true, true],
        ['مانیتورینگ کاربران', false, true, true, true],
        ['نجوا', false, true, true, true],
        ['کنترل تماس', false, true, true, true],
        ['ورود به مکالمه', false, true, true, true],
        ['والبورد', false, true, true, true]
      ]
    },
    {
      title: 'گزارشات مرکز تلفن',
      items: [
        ['سوابق تماس', true, true, true, true],
        ['وضعیت تماس', true, true, true, true],
        ['عملکرد پاسخگویی کاربر', true, true, true, true],
        ['ضبط مکالمات', true, true, true, true],
        ['نتایج نظرسنجی مکالمات', true, true, true, true],
        ['تماس‌های از دست رفته', false, true, true, true],
        ['گزارش های پیشرفته', false, true, true, true]
      ]
    },
    {
      title: 'نمودار ها',
      items: [
        ['نمودار پراکندگی تماس‌ها', false, true, true, true],
        ['نمودار تاریخچه هزینه‌ها', true, true, true, true],
        ['نمودار صبر مشتری', false, true, true, true]
      ]
    },
    {
      title: 'امکانات عمومی مرکز تلفن',
      items: [
        ['اتصال داخلی ها به شماره های چهار و پنج رقمی', true, true, true, true],
        ['پنهان سازی Caller ID تماس‌های ورودی', true, true, true, true],
        ['امکان شماره گیری مستقیم داخلی ها در شماره های ۴ و ۵ رقمی', true, true, true, true],
        ['فعال سازی نظر سنجی تماس های خروجی', true, true, true, true],
        ['کال‌پیک آپ', true, true, true, true],
        ['فعال سازی ضبط تماس های خروجی', true, true, true, true],
        ['فعال سازی ضبط تماس های داخلی', true, true, true, true],
        ['برقراری تماس از طریق API', false, 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['برقراری تماس امن دوطرفه', false, 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    },
    {
      title: 'تنظیمات کاربری',
      items: [
        ['تعریف کاربر', true, true, true, true],
        ['تعریف کاربر IP-Phone', true, true, true, true],
        ['مدیریت نقش، سطوح و حقوق اختصاصی', false, true, true, true],
        ['تعریف دپارتمان', false, true, true, true],
        ['نمایش پاپ آپ تماس', false, true, true, true],
        ['یکپارچه‌سازی با واتس اپ', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'پنل پیامکی',
      items: [
        ['تعریف مخاطب', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف مخاطبان با فایل اکسل', 'قابل خرید', 'قابل خرید', true, true],
        ['ایجاد، ویرایش و حذف گروه', 'قابل خرید', 'قابل خرید', true, true],
        ['جستجو و فیلتر گروه‌ها', 'قابل خرید', 'قابل خرید', true, true],
        ['جستجو و فیلتر مخاطبان', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف عناوین پیش‌فرض', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف متن پیش‌فرض پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['زمان‌بندی ارسال پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال تکی پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال به گروه مخاطبان', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال انبوه با فایل اکسل', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال پیامک متناظر', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال پیامک پارامتریک', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال OTP', 'قابل خرید', 'قابل خرید', true, true],
        ['امکانات ویژه برنامه نویسان', 'قابل خرید', 'قابل خرید', true, true],
        ['گزارش ارسال', 'قابل خرید', 'قابل خرید', true, true],
        ['گزارش دریافت', 'قابل خرید', 'قابل خرید', true, true],
        ['پاسخ به پیامک های دریافتی', 'قابل خرید', 'قابل خرید', true, true],
        ['ایجاد لید و فرصت فروش از پیامک های دریافتی', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'وب چت',
      items: [
        ['تعریف وب سایت', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف اپراتور و سطوح دسترسی', 'قابل خرید', 'قابل خرید', true, true],
        ['ایجاد دپارتمان', 'قابل خرید', 'قابل خرید', true, true],
        ['شخصی سازی', 'قابل خرید', 'قابل خرید', true, true],
        ['پاسخگویی از طریق پنل و اپلیکیشن', 'قابل خرید', 'قابل خرید', true, true],
        ['نمایش تاریخچه گفتگوها', 'قابل خرید', 'قابل خرید', true, true],
        ['ثبت سرنخ و تیکت از گفتگو', 'قابل خرید', 'قابل خرید', true, true],
        ['جستجو و فیلتر گفتگوها', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'اشخاص',
      items: [
        ['ایجاد مخاطب', false, true, true, true],
        ['ایجاد مخاطبان با فایل اکسل', false, true, true, true],
        ['خروجی اکسل', false, true, true, true],
        ['جستجو و فیلتر پیشرفته', false, true, true, true],
        ['امکان عملیات گروهی (حذف، ایجاد وظیفه و اختصاص به کاربر)', false, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['ثبت تاریخ آخرین ارتباط', false, true, true, true],
        ['تعیین کارشناس پیگیری', false, true, true, true],
        ['مدیریت لیبل‌های پروفایل', false, true, true, true],
        ['تاریخچه تعاملات', false, true, true, true],
        ['حذف پروفایل', false, true, true, true],
        ['ثبت اطلاعات ارتباطی', false, true, true, true],
        ['ثبت اطلاعات شخصی', false, true, true, true],
        ['ثبت اطلاعات کسب و کار و حوزه فعالیت', false, true, true, true],
        ['ایجاد تیکت از پروفایل', false, false, true, true],
        ['ایجاد فاکتور و پیش فاکتور', false, false, false, true],
        ['ایجاد فرصت فروش', false, false, true, true],
        ['بارگذاری مدارک هویتی', false, true, true, true],
        ['ایجاد ارتباط بین شخص و شرکت', false, true, true, true],
        ['بارگذاری فایل های پیوست', false, true, true, true],
        ['تاریخچه تماس ها', false, true, true, true],
        ['تاریخچه وب چت', false, false, true, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه پیامک ها', false, false, true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['تعریف فیلد های اختصاصی', false, false, true, true],
        ['تاریخچه تغییرات', false, true, true, true],
        ['ثبت یادداشت', false, true, true, true]
      ]
    },
    {
      title: 'شرکت‌ها',
      items: [
        ['ایجاد مخاطب', false, true, true, true],
        ['ایجاد مخاطبان با فایل اکسل', false, true, true, true],
        ['خروجی اکسل', false, true, true, true],
        ['جستجو و فیلتر پیشرفته', false, true, true, true],
        ['امکان عملیات گروهی (حذف، ایجاد وظیفه و اختصاص به کاربر)', false, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['ثبت تاریخ آخرین ارتباط', false, true, true, true],
        ['تعیین کارشناس پیگیری', false, true, true, true],
        ['مدیریت لیبل‌های پروفایل', false, true, true, true],
        ['تاریخچه تعاملات', false, true, true, true],
        ['حذف پروفایل', false, true, true, true],
        ['ثبت اطلاعات ارتباطی', false, true, true, true],
        ['ثبت اطلاعات شرکتی', false, true, true, true],
        ['ثبت اطلاعات کسب و کار و حوزه فعالیت', false, true, true, true],
        ['ایجاد تیکت از پروفایل', false, false, true, true],
        ['ایجاد فاکتور و پیش فاکتور', false, false, false, true],
        ['ایجاد فرصت فروش', false, false, true, true],
        ['بارگذاری مدارک هویتی', false, true, true, true],
        ['ایجاد ارتباط بین شخص و شرکت', false, true, true, true],
        ['بارگذاری فایل های پیوست', false, true, true, true],
        ['تاریخچه تماس ها', false, true, true, true],
        ['تاریخچه وب چت', false, false, true, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه پیامک ها', false, 'قابل خرید', true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['تعریف فیلد های اختصاصی', false, true, true, true],
        ['تاریخچه تغییرات', false, true, true, true],
        ['ثبت یادداشت', false, true, true, true]
      ]
    },
    {
      title: 'تاریخچه تعاملات شرکت',
      items: [
        ['فیلتر گذاری درحالت های مختلف در گزارش گیری تاریخچه', false, false, true, true],
        ['قابلیت کلیک تو کال جهت تسریع ارتباط با مخاطب یا سرنخ', false, false, true, true],
        ['مشاهده تاریخچه تعاملات', false, false, true, true],
        ['افزودن مخاطب', false, false, true, true],
        ['افزودن سرنخ', false, false, true, true]
      ]
    },
    {
      title: 'سرنخ‌ها',
      items: [
        ['ایجاد سرنخ', false, false, false, true],
        ['ایجاد سرنخ با فایل اکسل', false, false, false, true],
        ['آرشیو سرنخ بصورت تکی و گروهی', false, false, false, true],
        ['جستجو و فیلتر پیشرفته', false, false, false, true],
        ['امکان عملیات گروهی (حذف، ایجاد وظیفه و اختصاص به کاربر)', false, false, false, true],
        ['کلیک تو کال', false, false, false, true],
        ['تعریف وظیفه', false, false, false, true],
        ['ثبت تاریخ آخرین ارتباط', false, false, false, true],
        ['تعیین کارشناس پیگیری', false, false, false, true],
        ['تاریخچه تعاملات', false, false, false, true],
        ['حذف سرنخ', false, false, false, true],
        ['پروفایل اختصاصی', false, false, false, true],
        ['تبدیل یک سرنخ به شخص و شرکت', false, false, false, true],
        ['ثبت اطلاعات ارتباطی', false, false, false, true],
        ['تاریخچه تغییرات', false, false, false, true],
        ['نمایش اطلاعات کمپین', false, false, false, true],
        ['تاریخچه تماس ها', false, false, false, true],
        ['تاریخچه وب چت', false, false, false, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', false, true],
        ['تاریخچه پیامک ها', false, false, false, true],
        ['تعریف وظیفه', false, false, false, true],
        ['ثبت یادداشت', false, false, false, true]
      ]
    },
    {
      title: 'فرصت های فروش',
      items: [
        ['ایجاد فرصت فروش', false, false, false, true],
        ['خروجی اکسل', false, false, false, true],
        ['نمایش بصورت بُرد کانبان', false, false, false, true],
        ['کلیک تو کال', false, false, false, true],
        ['نمایش بصورت کارت', false, false, false, true],
        ['نمایش بصورت جدولی', false, false, false, true],
        ['جستجو و فیلتر پیشرفته', false, false, false, true],
        ['آرشیو فرصت فروش', false, false, false, true],
        ['عملیات گروهی (حذف)', false, false, false, true],
        ['سورتینگ متناسب با فیلتر های دلخواه', false, false, false, true],
        ['تعیین کارشناس پیگیری', false, false, false, true],
        ['تعیین عناوین فرصت های فروش', false, false, false, true],
        ['تعیین اولویت برای فرصت فروش', false, false, false, true],
        ['ایجاد ارتباط با سایر بخش های CRM', false, false, false, true],
        ['تاریخچه تغییرات', false, false, false, true],
        ['تاریخچه تماس ها', false, false, false, true],
        ['تاریخچه وب چت', false, false, false, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', false, true],
        ['تاریخچه پیامک ها', false, false, false, true],
        ['تعریف وظیفه', false, false, false, true],
        ['ثبت یادداشت', false, false, false, true],
        ['ایجاد فاکتور و پیش فاکتور', false, false, false, true],
        ['تعریف محصول برای فرصت فروش', false, false, false, true],
        ['مرحله بندی برای فرصت فروش تا زمان نهایی شدن آن', false, false, false, true],
        ['تعریف دلایل موفقیت و عدم موفقیت', false, false, false, true]
      ]
    },
    {
      title: 'وظیفه‌ها',
      items: [
        ['تعریف وظیفه', false, false, true, true],
        ['جستجو و فیلتر پیشرفته', false, false, true, true],
        ['تعیین عناوین وظیفه', false, false, true, true],
        ['تعیین نوع وظیفه', false, false, true, true],
        ['تعیین مهلت انجام، یادآوری و مدت زمان وظایف', false, false, true, true],
        ['ایجاد ارتباط با سایر بخش های CRM', false, false, true, true],
        ['تاریخچه تغییرات', false, false, true, true],
        ['حذف وظیفه', false, false, true, true],
        ['تغییر وضعیت وظیفه', false, false, true, true],
        ['ثبت نظر', false, false, true, true],
        ['کلیک تو کال', false, false, true, true]
      ]
    },
    {
      title: 'تیکتینگ',
      items: [
        ['ایجاد تیکت', false, false, true, true],
        ['خروجی اکسل', false, false, true, true],
        ['تغییر حالت نمایش', false, false, true, true],
        ['کلیک تو کال', false, false, true, true],
        ['جستجو و فیلتر پیشرفته', false, false, true, true],
        ['آرشیو تیکت', false, false, true, true],
        ['عملیات گروهی (حذف)', false, false, true, true],
        ['سورتینگ متناسب با فیلتر های دلخواه', false, false, true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['تعیین کارشناس پیگیری', false, false, true, true],
        ['تعیین عناوین تیکت', false, false, true, true],
        ['ایجاد ارتباط با سایر بخش های CRM', false, false, true, true],
        ['ثبت توضیحات تیکت', false, false, true, true],
        ['تعیین نوع تیکت', false, false, true, true],
        ['ثبت حس مخاطب', false, false, true, true],
        ['تاریخچه تماس ها', false, false, true, true],
        ['تاریخچه وب چت', false, false, true, true],
        ['مشاهده چت های صورت گرفته از طریق واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['مشاهده پیامک های ارسال شده', false, false, true, true],
        ['تاریخچه واتس‌اپ', false, false, true, true],
        ['ثبت یادداشت', false, false, true, true],
        ['پاسخ به تیکت', false, false, true, true],
        ['تعیین وضعیت تیکت', false, false, true, true]
      ]
    },
    {
      title: 'فاکتور/پیش فاکتور',
      items: [
        ['ایجاد فاکتور و پیش فاکتور', false, false, false, true],
        ['ایجاد فاکتور و پیش فاکتور با فایل اکسل', false, false, false, true],
        ['جستجو و فیلتر پیشرفته', false, false, false, true],
        ['کلیک تو کال', false, false, false, true],
        ['خروجی اکسل و پی دی اف', false, false, false, true],
        ['حذف و ابطال فاکتور و پیش فاکتور', false, false, false, true],
        ['تاریخچه تغییرات', false, false, false, true],
        ['ارسال فاکتور و پیش فاکتور از طریق واتس اپ', false, false, false, true],
        ['ارسال فاکتور و پیش فاکتور از طریق پیامک', false, false, false, true],
        ['تنظیمات عمومی', false, false, false, true],
        ['تعیین قالب شخصی سازی شده', false, false, false, true],
        ['تنظیمات پیشرفته', false, false, false, true]
      ]
    },
    {
      title: 'محصولات',
      items: [
        ['ایجاد محصول', false, false, false, true],
        ['ایجاد محصول با فایل اکسل', false, false, false, true],
        ['تعریف دسته بندی', false, false, false, true],
        ['تعریف محصول متغیر', false, false, false, true],
        ['جستجو و فیلتر پیشرفته', false, false, false, true],
        ['تعیین نوع و واحد اندازه گیری', false, false, false, true],
        ['تعیین قیمت، کد و ارز', false, false, false, true],
        ['تاریخچه تغییرات', false, false, false, true],
        ['حذف محصول', false, false, false, true],
        ['فعال سازی و غیرفعال سازی', false, false, false, true]
      ]
    },
    {
      title: 'انبار',
      items: [
        ['ایجاد انبار', false, false, false, true],
        ['تعریف محصول متغیر', false, false, false, true],
        ['ورود محصول به انبار', false, false, false, true],
        ['خروجی اکسل', false, false, false, true],
        ['تاریخچه تغییرات', false, false, false, true],
        ['حذف و آرشیو انبار', false, false, false, true]
      ]
    },
    {
      title: 'اتوماسیون گردش کار',
      items: [
        ['فعال سازی گردش کار', false, false, true, true],
        ['مشاهده جزئیات و تغییرات درخصوص اجرای گردش کار', false, false, true, true],
        ['مشاهده گزارش گردش کار', false, false, true, true],
        ['مشاهده سوابق و تاریخچه تغییرات', false, false, true, true]
      ]
    },
    {
      title: 'ارزیابی عملکرد',
      items: [
        ['ثبت ارزیابی بر اساس KPIها', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['پخش مکالمه ضبط‌شده', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['جستجو و فیلتر ارزیابی‌ها', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['ثبت نمره و ارزیابی تماس', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش ارزیابی کاربران', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش نمرات ارزیابی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    },
    {
      title: 'فکس ابری',
      items: [
        ['ارسال و دریافت فکس', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش فکس‌های ارسالی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش فکس‌های دریافتی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    },
    {
      title: 'ویدئو کنفرانس',
      items: [
        ['کنفرانس عمومی و خصوصی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش تماس‌های ویدیویی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['جستجو و فیلتر', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    }
  ]
};


export const cloudPbxCompareWithTCI = [
  [
    'نوع تماس', 
    'هزینه تماس با سرشماره 8', 
    'هزینه تماس مخابرات', 
    'هزینه تماس با سرشماره 9'
  ],
  [
    'تماس با شماره ثابت خارج استان', 
    '33', 
    '33', 
    '30'
  ],
  [
    'تماس با شماره ثابت داخل استان', 
    '4.5', 
    '4.5', 
    '4'
  ],
  [
    'تماس با شماره تلفن همراه', 
    '62.5', 
    '62.5', 
    '55'
  ],
] as const;